import DeactivateAccountForm from './DeactivateAccountForm';

export default DeactivateAccountForm;
